// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-container {\r\n      width: 100px;\r\n      height: 40px;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      background-color: aquamarine;\r\n      border-radius: 5px;\r\n}\r\n\r\n.button-container:hover {\r\n      cursor: pointer;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
